export const DESCUENTO_MAYORISTA = 30;
export const MINIMO_UNIDADES_MAYORISTA = 20;

export const precioConDescuentoMayorista = (precioOriginal: number): number =>
  Math.round(precioOriginal * (1 - DESCUENTO_MAYORISTA / 100));

export const precioOriginalDesdeMayorista = (precioConDescuento: number): number =>
  precioConDescuento / (1 - DESCUENTO_MAYORISTA / 100);
